import { render, staticRenderFns } from "./Friends.vue?vue&type=template&id=7ba9653e&scoped=true"
import script from "./Friends.vue?vue&type=script&lang=ts"
export * from "./Friends.vue?vue&type=script&lang=ts"
import style0 from "./Friends.vue?vue&type=style&index=0&id=7ba9653e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba9653e",
  null
  
)

export default component.exports